export const faviconPath = require('@ms/yammer-assets/dist/web/ve/favicon.ico');
export const faviconDotPath = require('@ms/yammer-assets/dist/web/ve/faviconDot.ico');
